import { processResponse, processError } from './auth';

const getScenarios = (language = null) => {
  const url = new URL(process.env.GATSBY_BASE_URL + `livia/scenario/`);
  if (language) url.searchParams.append('language', language);

  const token = localStorage.getItem('accessToken');
  return fetch(url, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return processResponse(response);
    })
    .catch((err) => {
      processError(err, 'getScenarios');
    });
};

export { getScenarios };
